import styled from "styled-components";
import { cond, get, stubObject, stubTrue } from "lodash/fp";
import { rgba, position, size, tint } from "polished";
import { avatarTextSize } from "./avatar.utils.es.js";
const AvatarWrapper = styled("div").attrs({
  type: void 0
})(
  ({ theme }) => ({
    alignItems: "center",
    appearance: "none",
    background: "none",
    boxSizing: "border-box",
    color: rgba("white", 0.85),
    display: "flex",
    fontFamily: theme.fontFamily.default,
    fontWeight: theme.fontWeight.bold,
    justifyContent: "center",
    margin: 0,
    outline: 0,
    padding: 0,
    position: "relative",
    textDecoration: "none",
    "&::after": {
      borderRadius: "inherit",
      content: JSON.stringify("​"),
      lineHeight: 1,
      ...position("absolute", 0)
    }
  }),
  ({ theme, $displayMode, $showPlaceholderIfEmpty }) => $showPlaceholderIfEmpty ? {
    "&:empty": {
      background: "none",
      borderColor: $displayMode === "dark" ? theme.color.white6 : theme.color.gray5,
      borderStyle: "dashed",
      borderWidth: 1,
      boxShadow: "none"
    }
  } : void 0,
  ({ $appearance }) => $appearance === "outlined" ? {
    boxShadow: "0 0 0 1px white"
  } : void 0,
  ({ $magnitude }) => size(
    {
      xsmall: 16,
      small: 24,
      medium: 32,
      large: 48,
      xlarge: 64
    }[$magnitude]
  ),
  ({ $magnitude, theme, $variant }) => ((textSize) => ({
    fontSize: theme.fontSize[textSize],
    lineHeight: theme.lineHeight[textSize]
  }))(avatarTextSize($variant, $magnitude)),
  ({ $disabled, $variant }) => ({
    backgroundColor: tint(
      $disabled ? 0.5 : 0,
      {
        connection: "#74d487",
        individual: "#3bbebe",
        organisation: "#7db0d1"
      }[$variant]
    )
  }),
  ({ $variant }) => ({
    connection: {
      borderRadius: "50%"
    },
    individual: {
      borderRadius: "50%"
    },
    organisation: {
      borderRadius: 2
    }
  })[$variant],
  cond([
    [get("$disabled"), stubObject],
    [
      get("$interactive"),
      ({ $displayMode }) => ({
        cursor: "pointer",
        "&:hover": {
          "&::after": {
            backgroundColor: rgba("white", 0.15)
          }
        },
        "&:active, &[aria-expanded=true]": {
          "&::after": {
            backgroundColor: rgba("white", 0.25)
          }
        },
        "&:focus": {
          boxShadow: `0 0 0 2px ${$displayMode === "dark" ? rgba("white", 0.25) : rgba("black", 0.05)}`
        }
      })
    ],
    [stubTrue, stubObject]
  ])
);
const AvatarImageContainer = styled("div")({
  borderRadius: "inherit",
  background: "white",
  overflow: "hidden",
  ...position("absolute", 0),
  "&::after": {
    borderRadius: "inherit",
    border: `1px solid ${rgba("black", 0.1)}`,
    content: JSON.stringify("​"),
    display: "block",
    lineHeight: 1,
    ...position("absolute", 0)
  }
});
const AvatarImage = styled("img")(
  {
    display: "block",
    height: "100%",
    width: "100%"
  },
  ({ $objectFit }) => ({ objectFit: $objectFit })
);
export {
  AvatarImage,
  AvatarImageContainer,
  AvatarWrapper
};
